import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';

export const SMainContainer = styled(Container)(() => ({
    position: 'absolute',
    width: '100%',
    height: '100%',
}));
